export default {
  // SEO
  SEO: null,
  btn_checkout: null,
  // Carousel
  carousel_product_list: null,
  carousel_title: null,
  // General
  title: null,
  title_summary: null,
  subtotal: null,
  taxes: null,
  savings: null,
  shipping: null,
  shipping_free: null,
  total: null,
  show_afterpay: null,
  title_delivery: null,
  title_return: null,
  title_payment: null,
  empty_title: null,
  empty_text: null,
  discount: null,
  product_color: null,
  product_size: null,
  quantity: null,
  remove: null,
}
